var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style) {
buf.push("<h3>Форма обратной связи</h3><p>Воспользуйтесь данной формой, для того, чтобы отправить ваш вопрос.\n<br>Мы обязательно ответим вам в ближайшее время.\n</p><form v-on=\"submit:submit\"" + (jade.cls([style.feedback], [true])) + "><textarea rows=\"6\" v-model=\"feedback\" v-attr=\"disabled: blockForm\" v-show=\"show\" placeholder=\"Ваш вопрос...\" required" + (jade.cls([style.textarea], [true])) + "></textarea><component is=\"alert\" name=\"{{ name }}\" data-message=\"{{ data.message }}\"></component><button v-attr=\"disabled: blockForm\" v-show=\"show\"" + (jade.cls(['button',style.btn], [null,true])) + ">Отправить</button><p v-show=\"!show\"><strong>{{ data.message || 'Сообщение отправлено!'}}</strong></p></form>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/feedback/template.jade
 ** module id = 202
 ** module chunks = 0
 **/